import React from "react";

const CampaignSelector = ({ value, onChange, onSelect, options = [] }) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    if (onSelect) {
      onSelect(newValue);
    }
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[180px]"
      role="combobox"
      aria-label="Select campaign/automation"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default CampaignSelector;
